"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postStartCheckout = exports.fetchRecommendationsSuccess = exports.fetchRecommendations = exports.purgeThanks = exports.postPaymentSuccess = exports.postPaymentRecurrent = exports.postPaymentCreditCard = exports.postDeliveryAddress = exports.postDeliverySuccess = exports.postDelivery = exports.fetchDeliveryServicesFail = exports.fetchDeliveryServicesSuccess = exports.fetchDeliveryServices = exports.PURGE_THANKS = exports.POST_PAYMENT_SUCCESS = exports.FETCH_RECOMMENDATIONS_SUCCESS = exports.FETCH_RECOMMENDATIONS = exports.POST_PAYMENT_RECURRENT = exports.POST_PAYMENT_CREDIT_CARD = exports.POST_DELIVERY_SUCCESS = exports.POST_DELIVERY = exports.POST_DELIVERY_ADDRESS = exports.FETCH_DELIVERY_SERVICES_FAIL = exports.FETCH_DELIVERY_SERVICES_SUCCESS = exports.FETCH_DELIVERY_SERVICES = exports.ROOT = void 0;

var _api = require("@modules/api");

var _cart = require("@modules/cart");

var _snackbar = require("@modules/snackbar");

var _state = require("./state");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ROOT = '@@checkout';
exports.ROOT = ROOT;
var FETCH_DELIVERY_SERVICES = "".concat(ROOT, "/FETCH_DELIVERY_SERVICES");
exports.FETCH_DELIVERY_SERVICES = FETCH_DELIVERY_SERVICES;
var FETCH_DELIVERY_SERVICES_SUCCESS = "".concat(ROOT, "/FETCH_DELIVERY_SERVICES_SUCCESS");
exports.FETCH_DELIVERY_SERVICES_SUCCESS = FETCH_DELIVERY_SERVICES_SUCCESS;
var FETCH_DELIVERY_SERVICES_FAIL = "".concat(ROOT, "/FETCH_DELIVERY_SERVICES_FAIL");
exports.FETCH_DELIVERY_SERVICES_FAIL = FETCH_DELIVERY_SERVICES_FAIL;
var POST_DELIVERY_ADDRESS = "".concat(ROOT, "/POST_DELIVERY_ADDRESS");
exports.POST_DELIVERY_ADDRESS = POST_DELIVERY_ADDRESS;
var POST_DELIVERY = "".concat(ROOT, "/POST_DELIVERY");
exports.POST_DELIVERY = POST_DELIVERY;
var POST_DELIVERY_SUCCESS = "".concat(ROOT, "/POST_DELIVERY_SUCCESS");
exports.POST_DELIVERY_SUCCESS = POST_DELIVERY_SUCCESS;
var POST_PAYMENT_CREDIT_CARD = "".concat(ROOT, "/POST_PAYMENT_CREDIT_CARD");
exports.POST_PAYMENT_CREDIT_CARD = POST_PAYMENT_CREDIT_CARD;
var POST_PAYMENT_RECURRENT = "".concat(ROOT, "/POST_PAYMENT_RECURRENT");
exports.POST_PAYMENT_RECURRENT = POST_PAYMENT_RECURRENT;
var FETCH_RECOMMENDATIONS = "".concat(ROOT, "/FETCH_RECOMMENDATIONS");
exports.FETCH_RECOMMENDATIONS = FETCH_RECOMMENDATIONS;
var FETCH_RECOMMENDATIONS_SUCCESS = "".concat(ROOT, "/FETCH_RECOMMENDATIONS_SUCCESS");
exports.FETCH_RECOMMENDATIONS_SUCCESS = FETCH_RECOMMENDATIONS_SUCCESS;
var POST_PAYMENT_SUCCESS = "".concat(ROOT, "/POST_PAYMENT_SUCCESS");
exports.POST_PAYMENT_SUCCESS = POST_PAYMENT_SUCCESS;
var PURGE_THANKS = "".concat(ROOT, "/PURGE_THANKS");
exports.PURGE_THANKS = PURGE_THANKS;

var fetchDeliveryServices = function fetchDeliveryServices(cartID) {
  var _next;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_DELIVERY_SERVICES,
    route: "/deliveries/services?cart_id=".concat(cartID),
    next: (_next = {}, _defineProperty(_next, _api.apiActions.CALL_API_SUCCESS, fetchDeliveryServicesSuccess), _defineProperty(_next, _api.apiActions.CALL_API_FAIL, function (_ref) {
      var error = _ref.error;
      return [_snackbar.snackbarActions.show({
        message: error.literal
      }), fetchDeliveryServicesFail];
    }), _next),
    schema: _state.transformDeliveryServices
  };
};

exports.fetchDeliveryServices = fetchDeliveryServices;

var fetchDeliveryServicesSuccess = function fetchDeliveryServicesSuccess(services) {
  return {
    type: FETCH_DELIVERY_SERVICES_SUCCESS,
    services: services
  };
};

exports.fetchDeliveryServicesSuccess = fetchDeliveryServicesSuccess;

var fetchDeliveryServicesFail = function fetchDeliveryServicesFail() {
  return {
    type: FETCH_DELIVERY_SERVICES_FAIL
  };
};

exports.fetchDeliveryServicesFail = fetchDeliveryServicesFail;

var postDelivery = function postDelivery() {
  var _next2;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var route = arguments.length > 1 ? arguments[1] : undefined;
  return {
    type: _api.apiActions.CALL_API,
    call: POST_DELIVERY,
    route: "/carts/".concat(options.cartID, "/delivery"),
    next: (_next2 = {}, _defineProperty(_next2, _api.apiActions.CALL_API_SUCCESS, postDeliverySuccess), _defineProperty(_next2, _api.apiActions.CALL_API_FAIL, function (_ref2) {
      var error = _ref2.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next2),
    schema: _cart.cartMutator,
    nextArgs: [route],
    params: (0, _api.apiMakeRequestParams)({
      address_id: options.addressID,
      slot_id: options.slotID,
      delivery_date: options.deliveryDate,
      invoice_address_id: options.invoiceID || 0,
      comments: options.comments || ''
    }, {
      method: 'PUT'
    })
  };
};

exports.postDelivery = postDelivery;

var postDeliverySuccess = function postDeliverySuccess(payload, redirectRoute) {
  return {
    type: POST_DELIVERY_SUCCESS,
    redirectRoute: redirectRoute
  };
};

exports.postDeliverySuccess = postDeliverySuccess;

var postDeliveryAddress = function postDeliveryAddress(cartID, addressID) {
  var _next3;

  return {
    type: _api.apiActions.CALL_API,
    call: POST_DELIVERY_ADDRESS,
    route: "/carts/".concat(cartID, "/delivery-address"),
    next: (_next3 = {}, _defineProperty(_next3, _api.apiActions.CALL_API_SUCCESS, [_cart.cartActions.fetchCartSuccess, function () {
      return fetchDeliveryServices(cartID);
    }]), _defineProperty(_next3, _api.apiActions.CALL_API_FAIL, function (_ref3) {
      var error = _ref3.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next3),
    schema: _cart.cartMutator,
    params: (0, _api.apiMakeRequestParams)({
      address_id: addressID
    }, {
      method: 'PUT'
    })
  };
};

exports.postDeliveryAddress = postDeliveryAddress;

var postPaymentCreditCard = function postPaymentCreditCard(options, route) {
  var _next4;

  return {
    type: _api.apiActions.CALL_API,
    call: POST_PAYMENT_CREDIT_CARD,
    route: "/carts/checkout",
    next: (_next4 = {}, _defineProperty(_next4, _api.apiActions.CALL_API_SUCCESS, postPaymentSuccess), _defineProperty(_next4, _api.apiActions.CALL_API_FAIL, function (_ref4) {
      var error = _ref4.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next4),
    nextArgs: [route],
    params: (0, _api.apiMakeRequestParams)({
      card_holder: options.holder,
      card_number: options.number,
      cvv: options.cvv,
      exp_month: options.expirationMonth,
      exp_year: options.expirationYear,
      method: 'creditcard',
      remember: options.remember
    }),
    schema: _state.transformOrder
  };
};

exports.postPaymentCreditCard = postPaymentCreditCard;

var postPaymentRecurrent = function postPaymentRecurrent(creditCard, route) {
  var _next5;

  return {
    type: _api.apiActions.CALL_API,
    call: POST_PAYMENT_RECURRENT,
    route: "/carts/checkout",
    next: (_next5 = {}, _defineProperty(_next5, _api.apiActions.CALL_API_SUCCESS, postPaymentSuccess), _defineProperty(_next5, _api.apiActions.CALL_API_FAIL, function (_ref5) {
      var error = _ref5.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next5),
    nextArgs: [route],
    params: (0, _api.apiMakeRequestParams)({
      card: creditCard,
      method: 'recurrent',
      password: ''
    }),
    schema: _state.transformOrder
  };
};

exports.postPaymentRecurrent = postPaymentRecurrent;

var postPaymentSuccess = function postPaymentSuccess(order, redirectRoute) {
  return {
    type: POST_PAYMENT_SUCCESS,
    order: order,
    redirectRoute: redirectRoute
  };
};

exports.postPaymentSuccess = postPaymentSuccess;

var purgeThanks = function purgeThanks() {
  return {
    type: PURGE_THANKS
  };
};

exports.purgeThanks = purgeThanks;

var fetchRecommendations = function fetchRecommendations() {
  var _next6;

  return {
    type: _api.apiActions.CALL_API,
    call: FETCH_RECOMMENDATIONS,
    route: "/products/recommend?preset=web:checkout:upsell",
    next: (_next6 = {}, _defineProperty(_next6, _api.apiActions.CALL_API_SUCCESS, fetchRecommendationsSuccess), _defineProperty(_next6, _api.apiActions.CALL_API_FAIL, function (_ref6) {
      var error = _ref6.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next6),
    schema: _state.transformRecommendations
  };
};

exports.fetchRecommendations = fetchRecommendations;

var fetchRecommendationsSuccess = function fetchRecommendationsSuccess(recommendations) {
  return {
    type: FETCH_RECOMMENDATIONS_SUCCESS,
    recommendations: recommendations
  };
};

exports.fetchRecommendationsSuccess = fetchRecommendationsSuccess;

var postStartCheckout = function postStartCheckout(cartID) {
  var _next7;

  return {
    type: _api.apiActions.CALL_API,
    call: _cart.cartActions.FETCH_CART,
    route: "/carts/".concat(cartID, "/start-checkout"),
    schema: _cart.cartMutator,
    params: (0, _api.apiMakeRequestParams)({}, {
      method: 'POST'
    }),
    next: (_next7 = {}, _defineProperty(_next7, _api.apiActions.CALL_API_SUCCESS, _cart.cartActions.fetchCartSuccess), _defineProperty(_next7, _api.apiActions.CALL_API_FAIL, function (_ref7) {
      var error = _ref7.error;
      return _snackbar.snackbarActions.show({
        message: error.literal
      });
    }), _next7)
  };
};

exports.postStartCheckout = postStartCheckout;